import { lazyComponent } from '../../lib/lazy'
import type { WebModule } from '../../lib/modules'

export const module: WebModule = {
  routes: [],
  entityOverrides: {
    task: {
      ListPage: lazyComponent(() => import('./TasksPage'), 'TasksPage'),
    },
  },
}
